// 产品列表页共同的数据
const state = {
  productsLoading: false,
  // 所有品牌
  brands: [],
  // 品牌聚合
  aggBrands: [],
  allProperties: [],
  // 从元数据获取的聚合属性
  aggProperties: [],
  multi_room: [],
  // 聚合的产品系列选项[{id: number, name: string}]
  aggProductSeries: [],
  products: [],
  samplesMapping: [],
  existFeedbackVisit: false,
  totalCount: 0,
}
const getters = {
  aggProperties: (state) => state.aggProperties,
  aggProductSeries: (state) => state.aggProductSeries,
  products: (state) => state.products,
  samplesMapping: (state) => state.samplesMapping,
  allProperties: (state) => {
    return state.allProperties
  },
  productsLoading: (state) => state.productsLoading,
  totalCount: (state) => state.totalCount,
  brands: (state) => {
    const brands = state.brands || []
    return brands.map((item) => {
      item.disabled = !state.aggBrands.some((it) => it.brandCode === item.brandCode)
      return item
    })
  },
  existFeedbackVisit: (state) => state.existFeedbackVisit,
  // 用于筛选的产品属性
  searchProperties: (state) => {
    const arr = []
    state.aggProperties.forEach((item) => {
      const obj = {
        label: item.name,
        code: item.code,
        dataType: item.dataType,
        suffix: item.unitSymbol || null
      }
      if (item.dataType === 'Bool') {
        obj.values = [{ code: 1, name: '是' }, { code: 0, name: '否' }]
      } else if (item.dataType === 'Enum') {
        obj.values = item.values || []
      }
      arr.push(obj)
    })
    return arr
  },
}
const mutations = {
  setSelectionBrands(state, data) {
    state.selectionBrands = data
  },
  setProductsLoading(state, data) {
    state.productsLoading = data
  },
  setTotalCount(state, data) {
    state.totalCount = data
  },
  setBrands(state, data) {
    state.brands = data
  },
  setAggBrands(state, data) {
    state.aggBrands = data
  },
  setAggProperties(state, data) {
    state.aggProperties = data
  },
  setMulti_room(state, data) {
    state.multi_room = data
  },

  setAggProductSeries(state, data) {
    state.aggProductSeries = data
  },
  setAllProperties(state, data) {
    state.allProperties = data
  },
  setProducts(state, data) {
    state.products = data
  },
  setSamplesMapping(state, data) {
    state.samplesMapping = data
  },
  existFeedbackVisit(state, data) {
    state.existFeedbackVisit = data
  }
}
const actions = {
  async getSelectionBrands({ commit }, query) {
    try {
      const data = await this.$api.products.getSelectionBrands(query)
      commit('setSelectionBrands', data || [])
    } catch (error) {
      commit('setSelectionBrands', [])
      console.error(error)
    }
  },
  async loadBrands({ commit }, params) {
    try {
      const data = await this.$api.products.getAggBrands(params)
      commit('setBrands', data || [])
    } catch (error) {
      commit('setBrands', [])
      console.error(error)
    }
  },
  async loadAggBrands({ commit }, params) {
    try {
      const data = await this.$api.products.getAggBrands(params)
      commit('setAggBrands', data || [])
    } catch (error) {
      commit('setAggBrands', [])
      console.error(error)
    }
  },
  async loadAllProperties({ commit }, payload = {}) {
    try {
      const classification_code = payload.gjwCategoryCode
      delete payload.gjwCategoryCode
      const data = await this.$api.classification.getClassificationProperties(classification_code, payload)
      commit('setAllProperties', data || [])
    } catch (error) {
      commit('setAllProperties', [])
      console.error(error)
    }
  },
  async loadAggProperties({ commit }, payload = {}) {
    try {
      const data = await this.$api.products.getAggProperties(payload)
      commit('setAggProperties', data || [])
    } catch (error) {
      commit('setAggProperties', [])
      console.error(error)
    }
  },
  // 获取产品系列聚合结果
  async loadAggProductSeries({ commit }, payload = {}) {
    try {
      const data = await this.$api.products.getAggProductSeries(payload)
      commit('setAggProductSeries', data || [])
    } catch (error) {
      commit('setAggProductSeries', [])
      console.error(error)
    }
  },
  async existFeedbackVisit({ commit }, payload = {}) {
    try {
      const data = await this.$api.products.existFeedbackVisit(payload)
      commit('existFeedbackVisit', data)
    } catch (error) {
      commit('existFeedbackVisit', true)
      console.error(error)
    }
  },
  async feedback({ commit }, payload = {}) {
    try {
      await this.$api.products.feedback(payload)
    } catch (error) {
      console.error(error)
    }
  },
  async loadProducts({ commit }, payload = {}) {
    try {
      commit('setProductsLoading', true)
      const data = await this.$api.products.list(payload)
      const products = data.list || []
      const ids = products.map((item) => item.id)
      const sampleMapping = await this.$api.products.getBatchSamples(ids)
      commit('setProducts', products)
      commit('setSamplesMapping', sampleMapping || [])
      commit('setTotalCount', data.totalCount || 0)
      commit('setProductsLoading', false)
    } catch (error) {
      commit('setProducts', [])
      commit('setTotalCount', 0)
      commit('setProductsLoading', false)
      console.error(payload, error)
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
